module.exports = __webpack_public_path__ + "img/7841f76.jpg";